export default __webpack_public_path__ + "static/media/slide_2.0e8d69aa.jpg";